/** Vibration feedback on coarse-pointer devices. */

export class HapticsBus {
  private enabled = true;

  public setEnabled(on: boolean): void {
    this.enabled = on;
  }

  public pulse(pattern: number | number[]): void {
    if (!this.enabled || typeof navigator === "undefined") return;
    if (!window.matchMedia("(pointer: coarse)").matches) return;
    if (typeof navigator.vibrate !== "function") return;
    try {
      navigator.vibrate(pattern);
    } catch {
      // ignore unsupported vibrate
    }
  }

  public hullHit(): void {
    this.pulse(18);
  }

  public levelUp(): void {
    this.pulse([12, 40, 24]);
  }

  public multiKill(): void {
    this.pulse([8, 30, 8, 30, 16]);
  }

  public extractComplete(): void {
    this.pulse([20, 60, 40, 60, 80]);
  }

  /** Soft tick when a weapon slot leaves cooldown. */
  public weaponReady(): void {
    this.pulse(10);
  }

  /** Soft-lock acquired (rate-limited by sim assist_lock). */
  public softLock(): void {
    this.pulse([6, 18, 8]);
  }
}
